import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import './EmailVerification.css'; // This can share styles with VerificationPending.css

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';

const EmailVerification = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  
  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Invalid verification link. No token provided.');
        return;
      }
      
      try {
        const response = await fetch(`${API_BASE_URL}/api/users/verify-email/${token}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        });
        
        const data = await response.json();
        
        if (!response.ok) {
          throw new Error(data.error || 'Verification failed');
        }
        
        setStatus('success');
        setMessage(data.message || 'Your email has been verified successfully!');
        
        // Redirect to login after successful verification (after a delay)
        setTimeout(() => {
          navigate('/login?verified=true');
        }, 3000);
        
      } catch (error) {
        setStatus('error');
        setMessage(error.message || 'An error occurred during verification.');
      }
    };
    
    verifyToken();
  }, [token, navigate]);
  
  return (
    <div className="email-verification">
      <div className="verification-card">
        {status === 'verifying' && (
          <>
            <div className="icon loading">
              <div className="spinner"></div>
            </div>
            <h1>Verifying Your Email</h1>
            <p className="main-message">Please wait while we verify your email address...</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <div className="icon success">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#2ed573" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
            </div>
            <h1>Email Verified!</h1>
            <p className="main-message">{message}</p>
            <p className="redirect-message">You'll be redirected to login page shortly...</p>
            <div className="verification-actions">
              <Link to="/login" className="login-button">
                Go to Login
              </Link>
            </div>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="icon error">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ff4757" strokeWidth="2">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="15" y1="9" x2="9" y2="15"></line>
                <line x1="9" y1="9" x2="15" y2="15"></line>
              </svg>
            </div>
            <h1>Verification Failed</h1>
            <p className="main-message">{message}</p>
            <div className="verification-actions">
              <Link to="/verification-pending" className="resend-button">
                Request New Link
              </Link>
              <Link to="/login" className="login-link">
                Return to Login
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default EmailVerification;